
import { getAuthCode } from "./getAuthCode";
export const updateData = async (url,SetIsError,SetErrorMessage) => {
    try {
     let response = await fetch(process.env.REACT_APP_BACKEND_URL + "/updateinputs", {
        method: "POST",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({auth_code:await getAuthCode(),content:{url:url}}),
      });
      if(!response.ok){
        let json = await response.json();
        SetIsError(true)
        SetErrorMessage(json.message);
        console.log(json);
        return false
      }
      else{
        return true
      }
    } catch (error) {
      console.log(error);
    }
  };